/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboard: {
  name: 'keyboard';
  data: string;
} = {
  name: 'keyboard',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"/></svg>`
};
